import React from "react";
import { useRef } from "react";
import {
  Container,
  Title,
  Draggable,
  EventNode,
  IconDiv,
  HiddenElements,
  HiddenIconDiv,
} from "./styles";
import StartIcon from "../../../../assets/SideBar/StartIcon";
import EndIcon from "../../../../assets/SideBar/EndIcon";
import TimerIcon from "../../../../assets/SideBar/TimerIcon";
import TextIcon from "../../../../assets/SideBar/TextIcon";
const Events = ({ Label, onDrag }) => {
  const startIconRef = useRef(null);
  const endIconRef = useRef(null);
  const timerIconRef = useRef(null);
  const customTextIconRef = useRef(null);

  return (
    <Container>
      <Title>{Label}</Title>
      <Draggable>
        <EventNode
          style={{ marginRight: "0.125rem", marginBottom: "0.125rem" }}
          draggable
          onDragStart={(event) => {
            onDrag(event, "eventStart");
            if (startIconRef.current) {
              event.dataTransfer.setDragImage(startIconRef.current, -15, -15);
            }
          }}
        >
          <IconDiv>
            <StartIcon />
          </IconDiv>
          <span>Início</span>
        </EventNode>
        <EventNode
          style={{ marginBottom: "0.125rem" }}
          draggable
          onDragStart={(event) => {
            onDrag(event, "eventEnd");
            if (endIconRef.current) {
              event.dataTransfer.setDragImage(endIconRef.current, -15, -15);
            }
          }}
        >
          <IconDiv>
            <EndIcon />
          </IconDiv>
          <span>Fim</span>
        </EventNode>
        <EventNode
          draggable
          onDragStart={(event) => {
            onDrag(event, "timerEvent");
            if (timerIconRef.current) {
              event.dataTransfer.setDragImage(timerIconRef.current, -15, -15);
            }
          }}
          style={{ marginRight: "0.125rem" }}
        >
          <IconDiv>
            <TimerIcon />
          </IconDiv>
          <span>Temporizador</span>
        </EventNode>
        <EventNode
          draggable
          onDragStart={(event) => {
            onDrag(event, "customText");
            if (customTextIconRef.current) {
              event.dataTransfer.setDragImage(
                customTextIconRef.current,
                -15,
                -15
              );
            }
          }}
        >
          <IconDiv text>
            <TextIcon />
          </IconDiv>
          <span>Texto</span>
        </EventNode>

        <HiddenElements>
          <HiddenIconDiv ref={startIconRef}>
            <StartIcon />
          </HiddenIconDiv>
          <HiddenIconDiv ref={endIconRef}>
            <EndIcon />
          </HiddenIconDiv>
          <HiddenIconDiv ref={timerIconRef}>
            <TimerIcon />
          </HiddenIconDiv>
          <HiddenIconDiv text ref={customTextIconRef}>
            <TextIcon />
          </HiddenIconDiv>
        </HiddenElements>
      </Draggable>
    </Container>
  );
};

export default Events;
